export function delay(ms: number): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(() => resolve(), ms);
  });
}

export class Resolver<T = void> {
  readonly promise: Promise<T>;
  private resolveInternal!: (res: T) => void;
  private rejectInternal!: (e: unknown) => void;
  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolveInternal = resolve;
      this.rejectInternal = reject;
    });
  }

  resolve(res: T) {
    this.resolveInternal(res);
  }

  reject(err: unknown = undefined) {
    this.rejectInternal(err);
  }
}
